export const CSentryPropagationTargets = {
    LOCALHOST: 'localhost',
    ANY: /^\//,
    MODAK: 'https://.*.modak.live/.*'
} as const;